import React, { useState } from 'react'
import { getScheduleInvoices, uploadInvoiceSupportingDocument } from '../../../../_services/invoices.service'

import { Button } from '../../../../_components/Button'
import { InvoiceDetailsModal } from '../../../LenderViews/InvoiceDetails/InvoiceDetailsModal'
import { InvoiceFilesModal } from './InvoiceFilesModal/InvoiceFilesModal'
import { InvoicesTable } from '../../../LenderViews/InvoicesTable'
import { SearchableOverview } from '../../../../_components/SearchableOverview'
import { createColumn } from '../../../../_components/TableColumn'
import { defaultColumns } from '../../../LenderViews/InvoicesTable'
import { modalSelectors } from '../../../../_selectors/modal.selectors'
import styled from 'styled-components'

const S_Link = styled.div`
  font-weight: bold;
  width: 100%;
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
  a {
    display: inline-block;
    width: 100%;
    :hover {
      text-decoration: underline;
    }
  }
`

export const DetailDisplay = ({ schedule, scheduleId, openModal, onAddVerificationNote }) => {
  const [refresh, setRefresh] = useState()
  const modal = modalSelectors.useModal()

  let invoiceColumns = [...defaultColumns(schedule?.advance_rate)]
  invoiceColumns = invoiceColumns.filter((c) => {
    return c.id !== 'remaining' && c.accessor !== 'business.business_name'
  })
  invoiceColumns = invoiceColumns.filter((c) => {
    return c.accessor !== 'debtor_id'
  })
  if (schedule && schedule.state == 'pending') {
    //need purchase control, but generally the invoice columns should be good across the application
    invoiceColumns = invoiceColumns.filter((col) => col.accessor != 'state')
  }
  invoiceColumns.push(
    createColumn({
      type: 'boolean-indicator',
      mode: 'reverse',
      id: 'non_funded',
      headingText: 'Fund',
    })
  )
  invoiceColumns.push(
    {
      id: 'supporting_documents_count',
      headingText: 'Files',
      accessor: 'supporting_documents_count',
      Cell: (props) => {
        const { original } = props.row
        return (
          <S_Link
            onClick={() => {
              openModal(InvoiceFilesModal, {
                invoiceId: original.id,
              })
            }}
          >
            {props.value}
          </S_Link>
        )
      },
    },
    {
      headingText: '',
      accessor: 'id',
      disableSortBy: true,
      Cell: (props) => (
        <Button
          className="compact"
          onClick={() => {
            openModal(InvoiceDetailsModal, {
              invoice_id: props.value,
              onAddVerificationNote: () => {
                onAddVerificationNote()
                refresh()
              },
            })
          }}
          text="View"
        />
      ),
    }
  )
  return (
    <>
      <SearchableOverview
        change={modal.is_open}
        searchPlaceholder="Search Invoices"
        showSearchBar={false}
        views={[
          {
            title: 'Invoices',
            endpointCall: (searchParams) => {
              return getScheduleInvoices(searchParams, scheduleId).then((response) => {
                const { data = [], headers = {} } = response
                return {
                  results: data,
                  total_results: headers['total-count'] || 0,
                }
              })
            },
            requestMethod: 'GET',
            pageSize: 25,
            columns: invoiceColumns,
            fetchReload: (fn) => {
              // Passing a lambda to set the state to the function instead of the result of the function
              setRefresh(() => fn)
            },
            Component: ({ results, sort, handleSortChange, pageSize, columns, refresh }) => {
              return (
                <InvoicesTable
                  columns={columns}
                  invoices={results}
                  onFilesAccepted={async (acceptedFiles, row) => {
                    const { original } = row
                    await uploadInvoiceSupportingDocument(acceptedFiles[0], original.id)
                    refresh()
                  }}
                  onSortedChange={handleSortChange}
                  pageSize={pageSize}
                  sorted={sort}
                />
              )
            },
          },
        ]}
      />
    </>
  )
}
